import React , {useEffect,useState} from "react";
import { useParams } from 'react-router-dom';
import Activities from "./sublist/activities";
import { getIdData } from "../../../lib/studentinfo";
import Student12TopMenu from "../studentInfo/student12topmenu"
import Student911TopMenu from "../studentInfo/student911topmenu"
import GlobalStudentProgressCheck from "../../pages/common/globalstudentprogresscheck";

export default function InstructorStudentActivityList() {

  let { slug } = useParams();

  const [isStudent911, setisStudent911] = useState(false);
  const [isStudent12, setisStudent12] = useState(false);

  async function GetData() {
    const info = await getIdData(slug);
    if (info[0].role === "Student911") {
      setisStudent911(true);
    } else if (info[0].role === "Student12") {
      setisStudent12(true);
    }
  }
   
    useEffect(() => {
      GetData();
    }, []);

  return (
    <>
     {isStudent911 && <Student911TopMenu slug={slug} activeMenu={"Activity"} /> }
     {isStudent12 && <Student12TopMenu slug={slug} activeMenu={"Activity"} /> }
    <div className="tak-instruct-group">
      <div className="row">
        <div className="col-md-12">         
          <Activities slug={slug} show={true}/>
        </div>
      </div>
    </div>
    <div className="tak-instruct-group">
                  <div className="row">
                    <div className="col-md-12">
                      <GlobalStudentProgressCheck studentId={slug} type={"Activities"} />
                    </div>
                  </div>
                </div>
    </>
  );
}
